import {
    createCatalogCategory,
    deleteCatalogCategory,
    getCatalogCategory,
    updateCatalogCategory,
    getCatalogCategoryById,
} from "../../api/catalogCategory.js";
import { toArray, toObject } from "../../utils/languageContent";

const catalogCategory = {
    namespaced: true,
    state: {
        catalogCategories: [],
    },
    getters: {
        getMappedCatalog: (state) => {
            let mapToChild = function (obj) {
                obj = toObject(obj);
                if (obj.children && obj.children.length > 0) {
                    obj.children = obj.children.map(mapToChild);
                }
                return obj;
            };

            return state.catalogCategories.map(mapToChild);
        },
    },
    mutations: {
        SET_CATALOG_CATEGORIES: (state, payload) => {
            state.catalogCategories = payload;
        },
        ADD_CATALOG_CATEGORY: (state, payload) => {
            state.catalogCategories.push(payload);
            state.catalogCategories.total++;
        },
        UPDATE_CATALOG_CATEGORY: (state, payload) => {
            let catalogCategory = state.catalogCategories.find((p) => p._id === payload._id);
            catalogCategory = payload;
        },
        DELETE_CATALOG_CATEGORY: (state, id) => {
            state.catalogCategories = state.catalogCategories.filter((r) => r._id !== id);
            state.catalogCategories.total--;
        },
    },
    actions: {
        getCatalogCategories({ commit }) {
            return getCatalogCategory().then((response) => {
                commit("SET_CATALOG_CATEGORIES", response.data);
            });
        },
        getCatalogCategory({ state }, id) {
            return getCatalogCategoryById(id).then((response) => {
                const data = toObject(response.data);
                return Promise.resolve(data);
            });
        },
        createCatalogCategory({ commit }, payload) {
            return createCatalogCategory(toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("ADD_CATALOG_CATEGORY", data);
                return Promise.resolve(data);
            });
        },
        updateCatalogCategory({ commit }, payload) {
            return updateCatalogCategory(payload._id, toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("UPDATE_CATALOG_CATEGORY", data);
                return Promise.resolve(data);
            });
        },
        deleteCatalogCategory({ commit }, id) {
            return deleteCatalogCategory(id).then((response) => {
                commit("DELETE_CATALOG_CATEGORY", id);
                return Promise.resolve(response);
            });
        },
    },
};

export default catalogCategory;
